import { alert } from '@codeleap/modals'
import { BaseChatPackage } from '../utils'
import { EXCLUDED_WORDS_QUERY_KEY } from '../hooks/useExcludedWords'

function escapeRegExp(w: string) {
  return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

function buildWordRegex(w: string) {
  const escaped = escapeRegExp(w)
  return new RegExp(`(?<![\\p{L}\\p{N}])${escaped}(?![\\p{L}\\p{N}])`, 'iu')
}

export function findExcludedWordInText(words: string[], text: string): string | null {
  return words.find(w => buildWordRegex(w).test(text)) ?? null
}

export class ExcludedWordsService extends BaseChatPackage {
  findExcludedWord(text: string): string | null {
    const words = this.queryClient.client.getQueryData<string[]>(EXCLUDED_WORDS_QUERY_KEY) ?? []
    return findExcludedWordInText(words, text)
  }

  blockIfExcluded(text: string): boolean {
    const match = this.findExcludedWord(text)
    if (!match) return false
    alert.warn({
      title: 'Blocked message',
      body: 'You are trying to send a word that is not allowed. Please review your message and try again.',
      options: [{ text: 'OK', style: 'default' }],
    })
    return true
  }
}
